// extracted by mini-css-extract-plugin
export default {"userMessage":"Message_userMessage__3QpQV","fadeIn":"Message_fadeIn__mJrum","partnerMessage":"Message_partnerMessage__yo-Py"};